import ValidService from "../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
    "id": undefined, // optional - Mã tự sinh
    "code": undefined, // required, pattern: /^[a-z0-9-/]+$/ - Mã tham chiếu cho campaign
    "pattern_url": undefined, // required, pattern: /^https?:/// - Pattern để sinh đường dẫn redirect
};


// validation form
model.validForm = {
    code: [ValidService.required, ValidService.checkSpaceString], // required
};

model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "-code",
    defaultSort: ["code", "descending"],
    filters: "",
    recordSelected: [],

    dataSearch: {
        value: {
            code: "",
            pattern_url: "",
        },
        valid: {
            code: [],
            pattern_url: []
        },
        operator: {
            code: ":regex_i:",
            pattern_url: ":regex_i:",
        },
    },
};

export default model;
